import { createAction } from '@reduxjs/toolkit'

export const initStarted = createAction('app_init_started')

export const initReady = createAction('app_init_ready')

export const initFailed = createAction<{ error: string }>('app_init_failed')
